// src/admin/services/adBannerService.js

import api from "../../services/api";

export const bannerService = {

    async getBanners(search = "") {

        const response = await api.get(
            "/adverts/admin/banners/",
            {
                params: {
                    search,
                },
            }
        );

        return response.data;
    },

    async getBanner(id) {

        const { data } = await api.get(
            `/adverts/admin/banners/${id}/`
        );

        return data;
    },

    async createBanner(formData) {

        const { data } = await api.post(
            "/adverts/admin/banners/",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return data;
    },

    async updateBanner(id, formData) {

        const { data } = await api.patch(
            `/adverts/admin/banners/${id}/`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return data;
    },

    async deleteBanner(id) {

        await api.delete(
            `/adverts/admin/banners/${id}/`
        );
    },

};